export default __webpack_public_path__ + "static/media/5-stars.94432df3.svg";